// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveInfoBar_base--oxrLw","base__toolbar":"ReserveInfoBar_base__toolbar--3D_cM","baseToolbar":"ReserveInfoBar_base__toolbar--3D_cM","content":"ReserveInfoBar_content--2_v6v","button":"ReserveInfoBar_button--3VumP"};


//////////////////
// WEBPACK FOOTER
// ./components/ReserveInfoBar/ReserveInfoBar.scss
// module id = 2192
// module chunks = 11